import { render, staticRenderFns } from "./ResetPasswordPage.vue?vue&type=template&id=7524722d&scoped=true"
import script from "./ResetPasswordPage.vue?vue&type=script&lang=js"
export * from "./ResetPasswordPage.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordPage.vue?vue&type=style&index=0&id=7524722d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7524722d",
  null
  
)

export default component.exports